var _defs, _circle, _circle2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSymbolpackNew231({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;stroke:#fff;stroke-linejoin:round;stroke-width:0.41px;}.b{fill:#fff;}"))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 5.26,
    cy: 8,
    r: 3.88
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 5.26,
    cy: 8,
    r: 2.33
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M14.62,7.93a5.73,5.73,0,0,1-.06.84,3.36,3.36,0,0,1-.22.74,2.55,2.55,0,0,1-.39.63,2,2,0,0,1-.58.48,2.9,2.9,0,0,1-.8.31,4.58,4.58,0,0,1-1,.11H10.23V5H11.8a2.82,2.82,0,0,1,2.12.73A3.13,3.13,0,0,1,14.62,7.93ZM13.76,8a4.23,4.23,0,0,0-.13-1.09,1.74,1.74,0,0,0-.36-.72,1.45,1.45,0,0,0-.62-.4,2.88,2.88,0,0,0-.88-.12h-.71v4.66h.62C13.06,10.32,13.76,9.55,13.76,8Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymbolpackNew231);
export default __webpack_public_path__ + "static/media/Symbolpack_New_231.ac38f4cd9f0cbdb8eedc7ab30de7c8c4.svg";
export { ForwardRef as ReactComponent };